import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/consultations/neurology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	neurology: {
		id: "ktx.neurology.title",
		defaultMessage: "Neurológia"
	},
	result: {
		id: "ktx.neurology.field.result",
		defaultMessage:
			"Konzílium eredménye alapján (Kérjük neurológiai alapbetegség esetén mindenképpen töltse ki az űrlapot)"
	},
	comment: {
		id: "ktx.neurology.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_neurology",
	value: {
		schemaId: "neurology",
		title: messages.neurology,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
